export const allES = {
  PICK: 'Seleccionar respuesta',
  MATCH: 'Escribe tu respuesta aquí',
  FILL: 'Se debe seleccionar la respuesta',
  MISSING: 'Se deben seleccionar las respuestas',
  WRITING: 'Se deben completar los formularios',
  SPEAKING: 'Para comprobar, debe grabar sus respuestas',
  MODULES: 'Debes responder todas las preguntas'
}
